export const BY_RULE_FILTERS = 'By rule filters';
export const BY_TEAM_PERMISSIONS = 'By team permissions';
export const BY_TALENT_METRICS = 'By talent metrics';
export const BY_MANAGER_LEVEL_METRICS = 'By manager level metrics';
export const DYNAMIC = 'Dynamic';